import { render, staticRenderFns } from "./accountingService.vue?vue&type=template&id=64206546&scoped=true"
var script = {}
import style0 from "./accountingService.vue?vue&type=style&index=0&id=64206546&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64206546",
  null
  
)

export default component.exports